import {ISWECHAT} from './useragent';

/**
 * 腾讯体系下注册了 applink 的调用
 *
 * @param {Object} obj
 */
function callByAppLink(obj) {
    let appConfig = callAndroid.appConfig;
    let applink = appConfig.APPLINK;
    let appurl = '';
    let protocol = callAndroid.appConfig.PROTOCOL;
    let androidSchema = protocol + obj.action + '?' + obj.params;
    // + '&analyticsna=' + obj.analytics;

    console && console.log('androidSchema: ', androidSchema);
    appurl = applink + encodeURIComponent(androidSchema);
    location.href = appurl;
}

/**
 * 基本 schema 调起
 *
 * @param {Object} obj
 */
function callBySchema(obj) {
    let appConfig = callAndroid.appConfig;
    let appurl = '';
    let protocol = appConfig.PROTOCOL;
    let timer = null;
    let count = 0;
    let startTime = Date.parse(new Date());
    let node = document.createElement('iframe');
    let body = document.body;
    appurl = protocol + 'hxtman' +
        '?action=' + obj.action + obj.params;
    // + '&analyticsna=' + obj.analytics; //版本9.0.0

    console && console.log('androidSchema: ', appurl);
    setTimeout(function () {
        node.style.display = 'none';
        node.src = appurl;
        body.appendChild(node);
    }, 100);

    timer = setInterval(() => {
        count++;
        if (count >= 130) {
            clearInterval(timer);
            let endTime = Date.parse(new Date());
            // 正常时间2600ms，但如果调起成功，会切换后台，导致setInterval执行变缓，就超过了2600
            // 执行下面的逻辑时，如果时间差超过了3000，证明调起成功，否则失败
            if (endTime - startTime >= 3000) {
                node.remove();
                node = null;
            } else {
                obj.errorCallback();
            }
        }
    }, 20);
}

/**
 *  android 调起入口
 *
 * @param {Object} obj
 */
function callAndroid(obj) {
    if (ISWECHAT && callAndroid.appConfig.USEAPPLINK) {
        callByAppLink(obj);
    } else if (ISWECHAT && !callAndroid.appConfig.USEAPPLINK) {
        window.globalVue.$wxGuide();
    } else {
        callBySchema(obj);
    }
}
/**
 * 初始化基础 config
 */
callAndroid.initConfig = (appConfig) => {
    callAndroid.appConfig = appConfig;
};

export default callAndroid;